var map = {
	"./account-manager/index.vue": [
		"0417",
		"other"
	],
	"./account-security-old/index.vue": [
		"d783",
		"chunk-70a57dd2"
	],
	"./account-security/index.vue": [
		"65ec",
		"account-security"
	],
	"./accounts/layout/index.vue": [
		"0e97"
	],
	"./accounts/login-captcha/index.vue": [
		"7f9d",
		"chunk-927900ce"
	],
	"./accounts/login-other/index.vue": [
		"9f36",
		"chunk-7296320e"
	],
	"./accounts/login/index.vue": [
		"486a",
		"chunk-6a45e922"
	],
	"./accounts/password-reset/index.vue": [
		"f5c1",
		"chunk-3f9df793",
		"chunk-2d22d1f3"
	],
	"./accounts/register/index.vue": [
		"ccfa",
		"chunk-3f9df793",
		"chunk-2d222211"
	],
	"./how-the-gold-old/index.vue": [
		"0f1f",
		"chunk-f5d0e6c2"
	],
	"./how-the-gold/index.vue": [
		"94e7",
		"how-the-gold"
	],
	"./how-to-invest-old/index.vue": [
		"e147",
		"chunk-3d4d1051"
	],
	"./how-to-invest/index.vue": [
		"c5e4",
		"how-to-invest"
	],
	"./intro-quota/index.vue": [
		"576c",
		"my-market"
	],
	"./introduction-cn/index.vue": [
		"6c0e",
		"chunk-2884952c"
	],
	"./introduction-hk/index.vue": [
		"7c15",
		"introduction-hk"
	],
	"./introduction-stock/index.vue": [
		"e57b",
		"chunk-3116ac72"
	],
	"./introduction-usa/index.vue": [
		"4dc3",
		"introduction-usa"
	],
	"./my-market/index.vue": [
		"a910",
		"chunk-4de48eff"
	],
	"./my-market/item/index.vue": [
		"e63b",
		"chunk-6a8f6f08"
	],
	"./protocol-page/index.vue": [
		"c4de",
		"protocol"
	],
	"./tuyere/index.vue": [
		"01af"
	],
	"./why-choose-us-old/index.vue": [
		"3184",
		"chunk-3d01ba8f"
	],
	"./why-choose-us/index.vue": [
		"5328",
		"why-choose-us"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9014";
module.exports = webpackAsyncContext;